
import { SessionStateService } from '@abp/ng.core';
import { Component } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
  /**
   *
   */
  constructor(
    public ngxUiLoader: NgxUiLoaderService,
    private sessionStateService: SessionStateService,
  ) {}
  isOpenMenu: boolean = false;
  lang = this.sessionStateService.getLanguage();
  toggleOpen(toggle: boolean) {
    this.isOpenMenu = !this.isOpenMenu;
  }
}
